import React, { Component } from 'react'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import FinanceAnalysis from '../../../../../../../../../components/FinanceAnalysis'

@hocBlock(config.modules.report.key)
export default class Fanal extends Component {
    render() {
        return <FinanceAnalysis {...this.props} />
    }
}
